(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.MdaSignupCore = api;
})(typeof self !== 'undefined' ? self : this, function () {
  const KEY = 'mda-signup';
  const UNLOCK_KEY = 'mda-unlock';
  const MAX_AGE_MS = 60 * 24 * 60 * 60 * 1000;
  const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function cleanEmail(value) {
    const email = typeof value === 'string' ? value.trim() : '';
    return EMAIL_RE.test(email) ? email : '';
  }

  function remember(storage, record, nowMs) {
    const email = cleanEmail(record && record.email);
    if (!email) return null;
    const saved = { email, source: String(record.source || 'site'), popup: record.popup ? String(record.popup) : '', at: nowMs };
    try {
      storage.setItem(KEY, JSON.stringify(saved));
    } catch (e) {}
    return saved;
  }

  function recall(storage, nowMs) {
    try {
      const data = JSON.parse(storage.getItem(KEY) || 'null');
      const email = cleanEmail(data && data.email);
      if (!email || !fresh(data.at, nowMs)) return null;
      return { email, source: String(data.source || ''), popup: String(data.popup || ''), at: data.at };
    } catch (e) {
      return null;
    }
  }

  function forget(storage) {
    try {
      storage.removeItem(KEY);
      storage.removeItem(UNLOCK_KEY);
    } catch (e) {}
  }

  function fresh(at, nowMs) {
    return typeof at === 'number' && nowMs - at <= MAX_AGE_MS && at - nowMs <= MAX_AGE_MS;
  }

  function recallUnlock(storage, nowMs) {
    try {
      const data = JSON.parse(storage.getItem(UNLOCK_KEY) || 'null');
      if (!data || !fresh(data.at, nowMs)) return null;
      return { source: String(data.source || 'link'), at: data.at };
    } catch (e) {
      return null;
    }
  }

  function fromAliaEvent(detail) {
    const email = cleanEmail(detail && detail.email);
    if (!email) return null;
    return { email, source: 'alia', popup: detail.popupTitle || (detail.popupID ? String(detail.popupID) : '') };
  }

  return { KEY, UNLOCK_KEY, MAX_AGE_MS, cleanEmail, remember, recall, forget, recallUnlock, fromAliaEvent };
});

(() => {
  if (typeof window === 'undefined' || typeof document === 'undefined' || window.MdaSignup) return;
  const core = window.MdaSignupCore;
  if (!core) return;

  const storage = () => {
    try {
      return window.localStorage;
    } catch (e) {
      return null;
    }
  };

  function save(record) {
    const s = storage();
    const saved = s && core.remember(s, record, Date.now());
    if (saved) window.dispatchEvent(new CustomEvent('mda:signup', { detail: saved }));
    return saved;
  }

  document.addEventListener('alia:signup', (event) => {
    const record = core.fromAliaEvent(event.detail);
    if (record) save(record);
  });

  window.MdaSignup = {
    recall: () => {
      const s = storage();
      return s ? core.recall(s, Date.now()) : null;
    },
    remember: (email, source) => save({ email, source }),
    linkUnlock: () => {
      const s = storage();
      return s ? core.recallUnlock(s, Date.now()) : null;
    },
    forget: () => {
      const s = storage();
      if (s) core.forget(s);
    },
    onSignup: (callback) => {
      window.addEventListener('mda:signup', (event) => callback(event.detail));
    }
  };
})();
